module.exports = __webpack_public_path__ + "img/speaker.5b5267be.svg";